'use client'
import Filters from '@/app/[lng]/Classses/Filters/Filters'
import {
  addOrRemoveCompanyLocation,
  addOrRemoveCompanyLocationContinents,
  setCompanyLocation,
} from '@/app/globalRedux/filter/commonFilter'
import {
  addOrRemoveCriteria,
  setLanguages,
  setNewsFilterData,
  setNewsOrder,
  setNewsSortSelectedOption,
} from '@/app/globalRedux/filter/newsFilter'
import { AppDispatch, RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import { languages, ListType } from '@/app/types/constantDataType'
import SearchResultSort from '@/components/SearchResultSelect'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { closeModal } from '@/lib/filterMobileModalHandler'
import { getCriteriaList } from '@/services/generalDataServices'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import { InputAdornment, TextField } from '@mui/material'
import { usePathname } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ClearAllFilter from './CommonFilters/ClearAllFilter'
import CompanyLocationFilter from './CommonFilters/CompanyLocationFilter'
import GuestNewsModal from '../../myfructidor/(edit)/news/(GuestNewsModal)/GuestNewsModal'
import { usePageNumberUpdator } from '@/app/hooks/usePageParamUpdater'

const NewsFilter = () => {
  const { t } = useTranslation()
  const dispatch: AppDispatch = useDispatch()
  const newsFilter = useSelector((state: RootState) => state.newsFilter)
  const commonFilter = useSelector((state: RootState) => state.commonFilter)
  const user = useSelector((state: RootState) => state.user)
  const goToPage = usePageNumberUpdator()
  const {
    order: newsOrder,
    selectedNewsSortOption,
    clearFilter,
  } = useSelector((state: RootState) => state.newsFilter)

  const { criteriaList } = useSelector((state: RootState) => state.constantData)
  const [companyLocation, setCompanyLocationText] = useState<string>('')
  const pathName = usePathname()
  const showKeywordSearch = Filters.getTab(pathName) == 'NEWS'

  useEffect(() => {
    if (criteriaList?.length <= 0) {
      dispatch(getCriteriaList())
    }
  }, [])
  useEffect(() => {
    setCompanyLocationText('')
  }, [clearFilter])
  return (
    <div className="w-[299px] mobile:w-[360px]  ">
      <div className="flex flex-col gap-4">
        {user?.userRole !== 'fructidor_admin' && <GuestNewsModal />}
        <div className="text-[16px] px-[15px] py-[10px] shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border-2 border-solid border-[#ebebeb] w-full flex rounded">
          <ClearAllFilter />

          <span className="hidden mobile:block mobile:ms-3">
            <CloseIcon
              onClick={() => {
                closeModal('news-modal')
              }}
            />
          </span>
        </div>
      </div>
      <span className=" hidden mobile:block">
        <SearchResultSort
          options="NewsSort"
          selectedOption={selectedNewsSortOption}
          sortByFunction={(value) => {
            dispatch(setNewsSortSelectedOption(value))
          }}
          order={newsOrder}
          orderByFunction={(value) => {
            dispatch(setNewsOrder(value))
          }}
        />
      </span>
      <div>
        {showKeywordSearch && (
          <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
            <div>
              <Accordion
                type="single"
                collapsible
                defaultValue="keyword_search"
              >
                <AccordionItem value="keyword_search">
                  <AccordionTrigger className="text-[18px] font-semibold text-[#222] ">
                    {t('Keyword Search')}
                  </AccordionTrigger>
                  <AccordionContent>
                    <TextField
                      value={newsFilter?.searchTerm}
                      onChange={(e) => {
                        dispatch(
                          setNewsFilterData({
                            searchTerm: e.target.value,
                          })
                        )
                        goToPage({ newPageNo: 1 })
                      }}
                      className=" w-full"
                      placeholder={t('Search')}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className="ml-[10px] "
                          >
                            <SearchIcon className="!w-[17.6px] !h-[17.6px]" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        )}

        <CompanyLocationFilter
          searchTitle={'Company Location'}
          locationText={companyLocation}
          setLocationText={setCompanyLocationText}
          continentSelectedList={commonFilter?.companyLocationContinents}
          countrySelectedList={commonFilter?.companyLocation}
          setWholeLocation={setCompanyLocation}
          addOrRemoveSelectedCountryList={addOrRemoveCompanyLocation}
          addOrRemoveSelectedContinentList={
            addOrRemoveCompanyLocationContinents
          }
        />

        <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
          <div>
            <Accordion type="single" collapsible defaultValue="Criterias">
              <AccordionItem value="Criterias">
                <AccordionTrigger className="text-[18px] font-semibold text-[#222] pb-[0px]">
                  {t('Criteria')}
                </AccordionTrigger>
                <AccordionContent>
                  <div className="flex flex-col mt-[0px] gap-[8px]">
                    {criteriaList?.map((criteria: ListType) => (
                      <div
                        className="flex flex-row items-center gap-2"
                        key={`${criteria.name}$`}
                      >
                        <Checkbox
                          checked={newsFilter.criterias.includes(criteria.name)}
                          id={`criteria-checkbox-${criteria.name}`}
                          className="border-2 border-[#e0e0e0]"
                          onClick={() => {
                            dispatch(addOrRemoveCriteria(criteria.name))
                            goToPage({ newPageNo: 1 })
                          }}
                        />
                        <Label
                          htmlFor={`criteria-checkbox-${criteria.name}`}
                          className=" cursor-pointer text-sm not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                        >
                          {t(criteria.name)}
                        </Label>
                      </div>
                    ))}
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>

        <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
          <div>
            <Accordion type="single" collapsible defaultValue="Languages">
              <AccordionItem value="Languages">
                <AccordionTrigger className="text-[18px] font-semibold text-[#222] pb-[0px]">
                  {t('Languages')}
                </AccordionTrigger>
                <AccordionContent>
                  <div className="flex flex-col mt-[0px]">
                    <RadioGroup
                      defaultValue={newsFilter.language}
                      className="flex gap-4 items"
                      id="product_type"
                      onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                        const value = (e.target as HTMLInputElement).value
                        if (value) {
                          dispatch(setLanguages(value))
                          goToPage({
                            newPageNo: 1,
                            searchParam: 'newslng',
                            searchValue: value,
                          })
                        }
                      }}
                    >
                      <div className="flex flex-col gap-2 checked-color">
                        {languages.map((language: string) => (
                          <Label
                            key={language}
                            htmlFor={language}
                            className=" cursor-pointer flex gap-2 text-sm not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                          >
                            <RadioGroupItem
                              value={language}
                              className="!text-[#df7d2f]"
                              id={language}
                              checked={language == newsFilter.language}
                            />
                            {t(language)}
                          </Label>
                        ))}
                      </div>
                    </RadioGroup>
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewsFilter
